import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContactTracingGuard } from './contact-tracing/guards/contact-tracing.guard';
import { PagesType } from './lco/models/pages-type';
import { AuthGuard } from './auth/guards/auth.guard';
import { RedirectGuard } from '@shared/guards/redirect.guard';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./home/home.component').then(c => c.HomeComponent),
      },
      {
        path: 'lco',
        data: {
          type: PagesType.HOME,
          animation: 'home'
        },
        loadChildren: () => import('./lco/lco.module').then(m => m.LcoModule)
      },
      {
        path: 'pay',
        data: {
          type: PagesType.PAY,
          animation: 'pay'
        },
        loadChildren: () => import('./lco/lco.module').then(m => m.LcoModule)
      },
      {
        path: 'auth',
        data: {
          animation: 'auth'
        },
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
      },
      {
        path: 'admin',
        canActivate: [AuthGuard],
        data: {
          animation: 'admin'
        },
        loadChildren: () => import('./qr-code-assignment/qr-code-assignment.module').then(m => m.QrCodeAssignmentModule),
      },
      {
        path: 'contact-tracing',
        canActivate: [ContactTracingGuard],
        loadChildren: () => import('./contact-tracing/contact-tracing.module').then(m => m.ContactTracingModule),
        data: {
          animation: 'contact-tracing'
        },
      },
      {
        path: 'menu/:storeId',
        data: {
          animation: 'menu'
        },
        loadChildren: () => import('./shared/pages/menu/menu.module').then(m => m.MenuModule)
      },
      {
        path: 'privacy-policy',
        data: {
          animation: 'privacy'
        },
        loadChildren: () => import('./shared/pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule)
      },
      {
        path: 'covid_symptoms',
        data: {
          animation: 'covid'
        },
        loadChildren: () => import('./shared/pages/covid-symptoms/covid-symptoms.module').then(m => m.CovidSymptomsModule),
      },
      {
        path: 'location',
        data: {
          animation: 'location'
        },
        loadChildren: () => import('./shared/pages/location-fallback/location-fallback.module').then(m => m.LocationFallbackModule)
      },
    ]
  },
  {
    path: 'download-loyalty-app',
    canActivate: [RedirectGuard],
    component: RedirectGuard,
    data: {
      externalUrl: 'https://qrco.de/bbZGmU'
    }
  },
  {
    path: 'promo',
    data: {
      animation: 'promo'
    },
    loadChildren: () => import('./promo/promo-routes').then(m => m.PromoRoutes)
  },
  {
    path: '**',
    loadComponent: () => import('./not-found/not-found.component').then(c => c.NotFoundComponent),
    data: {
      animation: '404'
    },
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // preloadingStrategy: PreloadAllModules,
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
